import { PaymentBenefits } from 'app/components/payment-benefits';
import { Column } from 'app/design/primitives/box';

export function PaymentBenefitsSection({ padded = false }: { padded?: boolean }) {
  return padded ? (
    <Column paddingHorizontal="spacing.general.x4" paddingTop="spacing.general.x4">
      <PaymentBenefits />
    </Column>
  ) : (
    <PaymentBenefits />
  );
}
